import { render } from "./BuscarItensVendas.vue?vue&type=template&id=5d490922&scoped=true&ts=true"
import script from "./BuscarItensVendas.vue?vue&type=script&lang=ts"
export * from "./BuscarItensVendas.vue?vue&type=script&lang=ts"

import "./BuscarItensVendas.vue?vue&type=style&index=0&id=5d490922&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d490922"]])

export default __exports__